<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="Group 848">
			<path
				id="Vector"
				d="M20 10C20 4.47715 15.5229 0 10 0C4.47715 0 0 4.47715 0 10C0 14.9912 3.65684 19.1283 8.4375 19.8785V12.8906L5.89844 12.8906L5.89844 10L8.4375 10V7.79688C8.4375 5.29063 9.93047 3.90625 12.2146 3.90625C13.3088 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.95 6.5625 11.5625 7.3334 11.5625 8.12422V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3432 19.1283 20 14.9914 20 10Z"
				fill="#1877F2"
			/>
			<path
				id="Vector_2"
				d="M13.8926 12.8906L14.3359 10H11.5625V8.12422C11.5625 7.3334 11.95 6.5625 13.1922 6.5625H14.4531V4.10156C14.4531 4.10156 13.3088 3.90625 12.2146 3.90625C9.93047 3.90625 8.4375 5.29063 8.4375 7.79688V10H5.89844V12.8906H8.4375L8.4375 19.8785C8.94668 19.9584 9.46836 20 10 20C10.5316 20 11.0533 19.9584 11.5625 19.8785L11.5625 12.8906L13.8926 12.8906Z"
				fill="white"
			/>
		</g>
	</svg>
</template>
